<template>
  <div>
    <div class="container-fluid pt-0 row mx-0 bg-primary">
      <article
        class="
          container-fluid
          card
          col-sm-12 col-md-12 col-lg-10 col-xl-10
          mycard-scale
          my-4
        "
      >
        <page-breadcrumb :items="page.crumbs" />
        <h1 class="h3 my-3">{{ page.h1 }}</h1>
        <p class="p2em">
          以下回答只使用广西桂运宝科技有限公司已经公开的业务事实，方便搜索和生成式引擎引用。
        </p>
        <section v-for="item in page.faq" :key="item.question" class="mb-4">
          <h2 class="h5">{{ item.question }}</h2>
          <p class="p2em mb-0">{{ item.answer }}</p>
        </section>
      </article>
    </div>
  </div>
</template>

<script>
import { PAGES } from "@/seo/site";

/**
 * 问句式常见问题页，同步输出 FAQPage 结构化数据。
 */
export default {
  name: "Faq",
  computed: {
    page: function () {
      return PAGES.faq;
    },
  },
};
</script>
